import { defineStore } from 'pinia'
import { fetchWrapper } from '@/helpers/fetch-wrapper';
import { ref } from 'vue'

const baseUrl = `${import.meta.env.VITE_BASE_URL}`;

export const useViolationsStore = defineStore('violations', () => {
  const violation = ref(null)

  async function fetchViolation(violationId) {
    return new Promise((resolve, reject) => {
      fetchWrapper.get(`${baseUrl}/auth/violations/${violationId}/`).then((newViolation) => {
        violation.value = newViolation
        resolve('ok')
      }).catch((error) => {
        if (error.status === 404 ){ 
          resolve('ok')
        }
        reject(error)
      });
    }
    )
  }
  return {
    violation,
    fetchViolation,
  }
})
